import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';
import Qs from 'qs';

const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
};
/**
 * 获取原始数据列表
 * @param params{}
 * */
export const fetchRawDataList = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/event/mark/rawData/findPageList`,
            {
                params,
            },
            {
                ...config,
            },
        ),
    );
/**
 * 获取原始数据列表总数
 * @param params{}
 * */
export const fetchRawDataTotal = (params = {}) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/event/mark/rawData/findPageTotal`,
            {
                params,
            },
            {
                ...config,
            },
        ),
    );
/**
 * 保存标注任务
 * @param params{}
 * */
export const fetchSaveTask = (data = {}) =>
    new ExAxios((config) =>
        axios.post(`${g.getBaseServer()}/event/mark/save`, Qs.stringify(data, { indices: false }), {
            ...config,
            headers,
        }),
    );

/**
 * 获取标注任务信息
 * @param id 标注任务id
 * */
export const fetchTaskData = (id = '') =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/event/mark/getById`,
            {
                params: { id },
            },
            {
                ...config,
            },
        ),
    );
    /**
 * 修改标注数据的下标
 * @param id 标注任务id
 *@param markIndex  标注数据的下标
 * */

export const updateMarkIndex = (params) =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/event/mark/updateMarkIndex`,
            {
                params: { ...params },
            },
            {
                ...config,
            },
        ),
    );

/**
 * 获取事件类型
 * @param
 * */
export const fetchEventTye = () =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/event/type/findTreeList`,

            {
                ...config,
            },
        ),
    );
/**
 * 删除标注资源
 * @param
 * */
export const fetchDeleteAssetById = (id = '') =>
    new ExAxios((config) =>
        axios.get(
            `${g.getBaseServer()}/mark/data/deleteById`,

            {
                params: {
                    id,
                },
                ...config,
            },
        ),
    );

/**
 * 保存标注事件
 * @param params{}
 * */
export const fetchSaveEvent = (data = {}) =>
    new ExAxios((config) =>
        axios.post(`${g.getBaseServer()}/event/info/save`, Qs.stringify(data, { indices: false }), {
            ...config,
            headers,
        }),
    );

/**
 * 【树状机构区域数据】
 * @param params{}
 * */

export const getAreaFindList = (data = {}) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/userarea/purview/area/findList`, {
            ...config,
            headers,
        }),
    );

/**
 * 根据经纬度查询区域
 * @param params{}
 * */

export const getAreaByLongitudeAndLatitude = (data = {}) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/userarea/getAreaByLongitudeAndLatitude`, {
            ...config,
            params: {
                ...data,
            },
            headers,
        }),
    );

/**
 * 【辖区数据】
 * @param params{}
 * */

export const getJurisdictionFindList = (data = {}) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/jurisdiction/findList`, {
            ...config,
            headers,
        }),
    );

/**
 * 根据经纬度查询辖区
 * @param params{}
 * */

export const getEventJurisdiction = (data = {}) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/jurisdiction/getEventJurisdiction`, {
            ...config,
            params: {
                ...data,
            },
            headers,
        }),
    );
/**
 * 删除标注事件
 * @param params{}
 * */
export const fetchDeleteEventById = (id) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/info/deleteById`, {
            params: { id },
            ...config,
        }),
    );
/**
 * 历史事件列表
 * @param params{}
 * */
export const getHistoryEventList = (dataId) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/info/historyEventList`, {
            params: { dataId },
            ...config,
        }),
    );

/**
 * 通过照片ID获取相关历史图片
 * @param params{}
 * */
export const getHistoryPictureList = (dataId) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/info/historyPictureList`, {
            params: { dataId },
            ...config,
        }),
    );
/**
 * 通过照片ID获取相关历史图片
 * @param params{}
 * */
export const getfindHistoryEventByGrid = (dataId) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/info/findHistoryEventByGrid`, {
            params: { dataId },
            ...config,
        }),
    );
/**
 * 【合并事件】
 * @param params{}
 * */

export const saveEventMerge = (data = {}) =>
    new ExAxios((config) =>
        axios.post(`${g.getBaseServer()}/event/info/merge`, Qs.stringify(data, { indices: false }), {
            ...config,
            headers,
        }),
    );

/**
 * 通过照片ID获取当前照片的相关历史照片和事件
 * @param params{}
 * */
export const gethistoryPictureAndEventList = (data) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/event/info/historyPictureAndEventList`, {
            params: { ...data },
            ...config,
        }),
    );

// 上传文件
export const uploadFile = (data, onUploadProgress = function () {}) =>
    new ExAxios((config) =>
        axios.post(`${g.getBaseServer()}/uploadFile/uploadFileCommon`, data, {
            ...config,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress,
        }),
    );
/**
 * 上传文件
 * @param {*} data {file,dataType,markId 标注ID}
 * */
export const uploadMarkAsset = (data, onUploadProgress = function () {}) =>
    new ExAxios((config) =>
        axios.post(`${g.getBaseServer()}/event/mark/upload`, data, {
            ...config,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress,
        }),
    );

/**
 * 根据id获取用户信息
 */
export const fetchUserById = (params) =>
    new ExAxios((config) =>
        axios.get(`${g.getBaseServer()}/organ/account/getProfile`, {
            params,
            ...config,
        }),
    );
